import React from "react";

interface MobileMobilePreviewPageProps {
  data: any;
}

const MobileMobilePreviewPage: React.FC<MobileMobilePreviewPageProps> = ({
  data,
}) => {
  return (
    <div style={styles.frame}>
      {/* Notch */}
      <div style={styles.notch}>
        <div style={styles.speaker}></div>
        <div style={styles.camera}></div>
      </div>

      {/* Top Purple Section */}
      <div style={styles.topArea}>
        <div style={styles.topRow}>
          <span style={styles.hamburger}>☰</span>
        </div>
        <img
          src="/images/MobileORLogo.png"
          alt="App Logo"
          style={styles.appLogo}
        />
      </div>

      {/* White Rounded Section */}
      <div style={styles.whiteSection}>
        {/* Header area (non-clickable close icon) */}
        <div style={styles.headerArea}>
          <span style={styles.closeIcon}>✕</span>

          <div style={styles.campaignName}>
            {data.campaignName || "Campaign Title"}
          </div>

          <div style={styles.divider}></div>
        </div>

        {/* Scrollable Content */}
        <div style={styles.scrollInner} className="custom-scrollbar">
          <div
            className="description-preview"
            style={styles.description}
            dangerouslySetInnerHTML={{
              __html: data.description || "Your content here...",
            }}
          ></div>
        </div>
      </div>

      {/* Custom Scrollbar */}
      <style>
        {`
          .custom-scrollbar {
            scrollbar-width: thin;
            scrollbar-color: #b0b0b0 transparent;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: #b0b0b0;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: #8c8c8c;
          }
        `}
      </style>
    </div>
  );
};

export default MobileMobilePreviewPage;

const styles: { [key: string]: React.CSSProperties } = {
  frame: {
    width: "320px",
    height: "667px",
    border: "14px solid #222",
    borderRadius: "40px",
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },

  notch: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "200px",
    height: "15px",
    backgroundColor: "#222",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "4px 8px",
    zIndex: 3,
  },
  speaker: {
    width: "40px",
    height: "4px",
    backgroundColor: "white",
    borderRadius: "2px",
  },
  camera: {
    width: "8px",
    height: "10px",
    backgroundColor: "white",
    borderRadius: "50%",
    boxShadow: "0 0 1px #000",
    alignSelf: "flex-end",
  },

  topArea: {
    backgroundColor: "#63555B",
    paddingTop: "36px",
    paddingBottom: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },
  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "20px",
  },
  hamburger: { fontSize: "0.95rem", color: "white" },
  appLogo: { height: "70px", objectFit: "contain", marginTop: "8px" },

  whiteSection: {
    backgroundColor: "#fff",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "40px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    marginTop: "-20px", // smooth curve transition
    zIndex: 2,
    boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
  },

  headerArea: {
    padding: "20px 16px 0px 16px",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    top: "14px",
    right: "18px",
    fontSize: "16px",
    color: "#9b9b9b",
    cursor: "default", // not clickable
    userSelect: "none",
  },
  campaignName: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#222",
    textAlign: "left",
    marginTop: "20px",
  },
  divider: {
    width: "100%",
    height: "2px",
    backgroundColor: "#C19763",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "2px",
  },

  scrollInner: {
    flex: 1,
    overflowY: "auto",
    padding: "0 16px 16px 16px",
    WebkitOverflowScrolling: "touch",
  },
  description: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5",
    textAlign: "left",
  },
};